// src/services/mockLogisticAPI.js

// Simulate network delay
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const fetchRegionStock = async (filters) => {
  await delay(800);
  // Mock data for Top 10 Produk (Horizontal Bar Chart)
  return [
    { name: "BUKU TULIS SUMA C...", value: 24.6, formatted: "24.6 M" },
    { name: "KERTAS PRINT A4 H...", value: 12.8, formatted: "12.8 M" },
    { name: "KERTAS PRINT A4 H... (2)", value: 5.5, formatted: "5.5 M" },
    { name: "BUKU TULIS CAMPUS...", value: 4.9, formatted: "4.9 M" },
    { name: "KERTAS PRINT F4 H...", value: 4.3, formatted: "4.3 M" },
    { name: "BUKU TULIS CAMPUS... (2)", value: 3.9, formatted: "3.9 M" },
    { name: "BUKU TULIS CAMPUS... (3)", value: 3.3, formatted: "3.3 M" },
    { name: "BUKU TULIS SAMPUL...", value: 1.7, formatted: "1.7 M" },
    { name: "BUKU TULIS CAMPUS... (4)", value: 1.5, formatted: "1.5 M" },
    { name: "BUKU TULIS CAMPUS... (5)", value: 1.3, formatted: "1.3 M" },
  ];
};

export const fetchProductionData = async (filters) => {
  await delay(1000);
  // Mock data for Line Chart (Production Trends)
  return [
    { name: "Jan", target: 4000, actual: 2400 },
    { name: "Feb", target: 3000, actual: 1398 },
    { name: "Mar", target: 2000, actual: 9800 },
    { name: "Apr", target: 2780, actual: 3908 },
    { name: "May", target: 1890, actual: 4800 },
    { name: "Jun", target: 2390, actual: 3800 },
    { name: "Jul", target: 3490, actual: 4300 },
  ];
};

export const fetchDeliveryStatus = async (filters) => {
  await delay(1200);
  // Mock data for Map & Timeline
  return {
    routes: [
      { id: "SJ-001", from: [-6.2088, 106.8456], to: [-6.9147, 107.6098], status: "On Transit", driver: "Ahmad" }, // JKT to BDG
      { id: "SJ-002", from: [-6.2088, 106.8456], to: [-7.2504, 112.7688], status: "Delivered", driver: "Budi" },   // JKT to SBY
      { id: "SJ-003", from: [-6.2088, 106.8456], to: [-6.9932, 110.4203], status: "Pending", driver: "Cecep" },    // JKT to SMG
    ],
    timeline: [
      { id: 1, title: "SJ-002 Delivered to Surabaya", time: "10:30 AM", type: "success" },
      { id: 2, title: "SJ-001 Departed from Jakarta Warehouse", time: "08:15 AM", type: "transit" },
      { id: 3, title: "SJ-003 Waiting for loading", time: "07:00 AM", type: "pending" },
    ],
    summary: {
      delivered: 145,
      onTransit: 32,
      pending: 12
    }
  };
};

export const fetchIntelligentStockAnalysis = async (filters) => {
  await delay(1500);
  return [
    {
      id: "ITEM-001",
      name: "Buku Tulis Campus 58 Lembar",
      branch: "Gudang Bandung",
      currentStock: 150,
      minStock: 2000,
      yoySalesTrend: 15, // +15% YoY
      wipProduction: 0,
      inTransit: 0,
      otherBranchStock: [
        { branch: "Gudang Surabaya", stock: 15000 },
        { branch: "Gudang Jakarta", stock: 8000 }
      ],
      recommendation: {
        action: "MUTASI",
        source: "Gudang Surabaya",
        urgency: "CRITICAL"
      }
    },
    {
      id: "ITEM-002",
      name: "Kertas HVS A4 80gr",
      branch: "Gudang Jakarta",
      currentStock: 50,
      minStock: 5000,
      yoySalesTrend: 30, // +30% YoY
      wipProduction: 10000,
      inTransit: 0,
      otherBranchStock: [],
      recommendation: {
        action: "PRODUKSI BERJALAN",
        source: "Pabrik",
        urgency: "WARNING",
        notes: "ETA 2 Hari"
      }
    },
    {
      id: "ITEM-003",
      name: "Tinta Printer Hitam 100ml",
      branch: "Gudang Surabaya",
      currentStock: 0,
      minStock: 500,
      yoySalesTrend: -25, // -25% YoY (Slow moving)
      wipProduction: 0,
      inTransit: 0,
      otherBranchStock: [
        { branch: "Gudang Jakarta", stock: 200 }
      ],
      recommendation: {
        action: "HOLD",
        source: null,
        urgency: "LOW",
        notes: "Slow Moving Item (-25% YoY)"
      }
    },
    {
      id: "ITEM-004",
      name: "Pulpen Gel Hitam",
      branch: "Gudang Medan",
      currentStock: 10,
      minStock: 1000,
      yoySalesTrend: 5,
      wipProduction: 0,
      inTransit: 2500,
      otherBranchStock: [],
      recommendation: {
        action: "TRANSIT",
        source: "SJ-1092",
        urgency: "SAFE",
        notes: "Cukup untuk menutupi minimum"
      }
    },
    {
      id: "ITEM-005",
      name: "Buku Gambar A3",
      branch: "Gudang Semarang",
      currentStock: 120,
      minStock: 1000,
      yoySalesTrend: 45, // Demand spike
      wipProduction: 0,
      inTransit: 0,
      otherBranchStock: [
        { branch: "Gudang Bandung", stock: 500 },
        { branch: "Gudang Surabaya", stock: 200 }
      ],
      recommendation: {
        action: "PRODUKSI SEGERA",
        source: "Pabrik",
        urgency: "CRITICAL",
        notes: "Lonjakan Demand (+45% YoY) & Stok Cabang Lain Kurang"
      }
    }
  ];
};

export const fetchDistributionMatrix = async (filters) => {
  await delay(1200);
  return [
    {
      id: "ITEM-001",
      name: "Buku Tulis Campus 58 Lembar",
      branches: [
        { branchId: "JKT", name: "Jakarta", stock: 8000, wip: 2000, transit: 500, minStock: 3000, demand: 2500, lastYearSales: 9500 },
        { branchId: "SBY", name: "Surabaya", stock: 15000, wip: 0, transit: 1000, minStock: 4000, demand: 6000, lastYearSales: 14000 },
        { branchId: "BDG", name: "Bandung", stock: 150, wip: 0, transit: 0, minStock: 2000, demand: 3000, lastYearSales: 2800 },
        { branchId: "MDN", name: "Medan", stock: 4500, wip: 0, transit: 200, minStock: 2500, demand: 1200, lastYearSales: 1500 },
        { branchId: "MKS", name: "Makassar", stock: 3200, wip: 500, transit: 0, minStock: 1500, demand: 1000, lastYearSales: 1200 }
      ]
    },
    {
      id: "ITEM-002",
      name: "Kertas HVS A4 80gr",
      branches: [
        { branchId: "JKT", name: "Jakarta", stock: 50, wip: 10000, transit: 0, minStock: 5000, demand: 8000, lastYearSales: 12000 },
        { branchId: "SBY", name: "Surabaya", stock: 8000, wip: 0, transit: 500, minStock: 3000, demand: 4500, lastYearSales: 5000 },
        { branchId: "BDG", name: "Bandung", stock: 7500, wip: 0, transit: 0, minStock: 2500, demand: 2000, lastYearSales: 1800 },
        { branchId: "MDN", name: "Medan", stock: 1200, wip: 0, transit: 800, minStock: 2000, demand: 2500, lastYearSales: 2200 },
        { branchId: "MKS", name: "Makassar", stock: 4100, wip: 0, transit: 0, minStock: 2000, demand: 1500, lastYearSales: 1300 }
      ]
    },
    {
      id: "ITEM-003",
      name: "Tinta Printer Hitam 100ml",
      branches: [
        { branchId: "JKT", name: "Jakarta", stock: 200, wip: 0, transit: 0, minStock: 500, demand: 600, lastYearSales: 800 },
        { branchId: "SBY", name: "Surabaya", stock: 0, wip: 0, transit: 0, minStock: 500, demand: 300, lastYearSales: 400 },
        { branchId: "BDG", name: "Bandung", stock: 800, wip: 0, transit: 0, minStock: 300, demand: 150, lastYearSales: 100 },
        { branchId: "MDN", name: "Medan", stock: 150, wip: 0, transit: 100, minStock: 200, demand: 250, lastYearSales: 300 },
        { branchId: "MKS", name: "Makassar", stock: 300, wip: 0, transit: 0, minStock: 250, demand: 100, lastYearSales: 120 }
      ]
    },
    {
      id: "ITEM-004",
      name: "Buku Gambar A3",
      branches: [
        { branchId: "JKT", name: "Jakarta", stock: 2500, wip: 0, transit: 0, minStock: 1500, demand: 1200, lastYearSales: 1000 },
        { branchId: "SBY", name: "Surabaya", stock: 200, wip: 0, transit: 0, minStock: 1000, demand: 1500, lastYearSales: 1800 },
        { branchId: "BDG", name: "Bandung", stock: 500, wip: 0, transit: 0, minStock: 800, demand: 600, lastYearSales: 500 },
        { branchId: "MDN", name: "Medan", stock: 1800, wip: 0, transit: 0, minStock: 1200, demand: 900, lastYearSales: 800 },
        { branchId: "MKS", name: "Makassar", stock: 950, wip: 0, transit: 0, minStock: 500, demand: 400, lastYearSales: 350 }
      ]
    }
  ];
};

let savedPlansStore = [];

export const fetchSavedDistributionPlans = async () => {
  await delay(500);
  return savedPlansStore;
};

export const saveDistributionPlan = async (plan) => {
  await delay(500);
  const newPlan = { id: `PLAN-${Math.floor(Math.random() * 10000)}`, date: new Date().toISOString(), ...plan };
  savedPlansStore = [newPlan, ...savedPlansStore];
  return newPlan;
};

export const deleteDistributionPlan = async (planId) => {
  await delay(500);
  savedPlansStore = savedPlansStore.filter(p => p.id !== planId);
  return true;
};
